import React from 'react';
import { styled, css } from '@compiled/react';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import {
	CHART_SPACE_BOTTOM,
	CHART_SPACE_LEFT,
} from '../../../common/ui/batch-size-chart/constants';
import { SkeletonItem, LineThin, LineThick } from '../../../common/ui/loading-skeleton';

export const LoadingSkeleton = () => (
	<ChartWrapper>
		<Box xcss={weekBreakdownTitleStyles}>
			<SkeletonItem width="168px" height="16px" margin="0" />
		</Box>
		<TitleWrapper>
			<SkeletonItem width="248px" height="20px" margin={`0 ${token('space.100', '8px')} 0 0`} />
			<SkeletonItem width="192px" height={token('space.100', '8px')} margin="0" />
		</TitleWrapper>
		<SubTitleWrapper>
			<SkeletonItem width="192px" height={token('space.100', '8px')} margin="0" />
			<SkeletonItem width="208px" height={token('space.100', '8px')} margin="0" />
		</SubTitleWrapper>
		<GraphWrapper>
			<GraphYLabelArea>
				<SkeletonItem width={token('space.100', '8px')} height="144px" margin="0" />
			</GraphYLabelArea>
			<GraphAreaWithXLabelArea>
				<GraphArea>
					<LineThin />
					<LineThin />
					<LineThin />
					<LineThin />
					<LineThick />
				</GraphArea>
				<GraphXLabel>
					<SkeletonItem width="36px" height="12px" margin="0" />
				</GraphXLabel>
			</GraphAreaWithXLabelArea>
		</GraphWrapper>
	</ChartWrapper>
);

const graphBaseStyles = css({
	height: '272px',
});

const chartWrapperBaseStyles = css({
	padding: 0,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const ChartWrapper = styled.div(chartWrapperBaseStyles);

const weekBreakdownTitleStyles = xcss({
	height: 'space.300',
	marginBottom: 'space.400',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TitleWrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
	height: '24px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SubTitleWrapper = styled.div({
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	height: '24px',
	paddingRight: token('space.250', '20px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const GraphWrapper = styled.div(graphBaseStyles, {
	display: 'flex',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const GraphYLabelArea = styled.div({
	// Variables are in tokens, that is ok as long as variable is in token. https://atlassian.slack.com/archives/CFJ9DU39U/p1710907256253769?thread_ts=1710905654.799309&cid=CFJ9DU39U
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${CHART_SPACE_LEFT}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	paddingBottom: `${CHART_SPACE_BOTTOM}px`,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	paddingTop: token('space.800', '64px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const GraphAreaWithXLabelArea = styled.div({
	flex: 1,
	display: 'flex',
	flexDirection: 'column',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const GraphArea = styled.div({
	flex: 1,
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'space-between',
	alignItems: 'stretch',
	paddingTop: token('space.800', '64px'),
	paddingRight: token('space.250', '20px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const GraphXLabel = styled.div({
	// Variables are in tokens, that is ok as long as variable is in token. https://atlassian.slack.com/archives/CFJ9DU39U/p1710907256253769?thread_ts=1710905654.799309&cid=CFJ9DU39U
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${CHART_SPACE_BOTTOM}px`,
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'flex-end',
});
